import DashboardCercaKpiController from "./components/DashboardCercaKpiController";
import DashboardKpiPendentiController from "./components/DashboardKpiPendentiController";
import DashboardKpiStatiController from "./components/DashboardKpiStatiController";
import DashboardNotificheController from "./components/DashboardNotificheController";
import DashboardScadenzeController from "./components/DashboardScadenzeController";

export default function Home() {

    return (
        <div className="ns-home container-fluid">
            <div className={"row"}>
                <div className={"col-md-12"}>
                    <DashboardCercaKpiController/>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-md-4"}>
                    <DashboardKpiPendentiController/>
                </div>
                <div className={"col-md-4"}>
                    <DashboardKpiStatiController/>
                </div>
                <div className={"col-md-4"}>
                    <DashboardScadenzeController/>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-md-12"}>
                    <DashboardNotificheController/>
                </div>
            </div>
        </div>
    )
}